import { allocateVideoTitle } from '#shared/utils/videoIframeTitle'

// Keyed by embed URL so a hydrating client reuses the name the server allocated;
// useId() keeps a src-less frame from sharing a key with another component's.
export function useVideoIframeTitle() {
  const assigned = useState<Record<string, string>>('video-iframe-titles', () => ({}))
  // Raw, so allocating from a template or computed neither tracks nor triggers
  // the render effect. The same object is still what useState serialises.
  const store = toRaw(assigned.value)
  const instanceKey = useId()

  return function titleFor(candidates: Array<string | null | undefined>, src?: string | null): string {
    return allocateVideoTitle(store, candidates, src, instanceKey)
  }
}
